
import axios from '../../../helpers/private.axios'



export const getSingleDocumentTemplate = ( id ) => {

    return axios.get(`/api/documents/templates/${id}`);

}